function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#c5e4fa",
  d: "M29 3a28 28 0 100 56 28 28 0 100-56z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#e3f2ff",
  d: "M10.71 52.29a28 28 0 009.18 5.82L54 24v-6.43a28.1 28.1 0 00-3.71-4.86zm-1.95-2.05L48 11h-6L6.22 46.78a28.08 28.08 0 002.54 3.46zm-2.97-7.03L39 10l-3-2L4.36 39.64a27.81 27.81 0 001.43 3.57z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#72caaf",
  d: "M29 3a28 28 0 1028 28A28 28 0 0029 3zm0 50a22 22 0 1115.17-37.93l.68.67q.39.4.75.82A22 22 0 0129 53z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#66bfa1",
  d: "M29 53A22 22 0 017 31H5.34a4 4 0 00-3.95 4.71 28 28 0 0055.21 0A4 4 0 0052.66 31H51a22 22 0 01-22 22z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#f6d397",
  d: "M60.32 63H30a2 2 0 01-1.68-3.09L43.5 36.58a2 2 0 013.36 0L62 59.91A2 2 0 0160.32 63z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#ed7899",
  d: "M29 18a1 1 0 001-1v-2a1 1 0 00-2 0v2a1 1 0 001 1z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#8d6c9f",
  d: "M15 30h-2a1 1 0 000 2h2a1 1 0 000-2z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#ed7899",
  d: "M42 31a1 1 0 001 1h2a1 1 0 000-2h-2a1 1 0 00-1 1z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#8d6c9f",
  d: "M29 44a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "#ed7899",
  d: "M33.87 18.95a1 1 0 001.3-.55l.75-1.85a1 1 0 00-1.85-.75l-.75 1.85a1 1 0 00.55 1.3zM38 20.24a1 1 0 001.44 1.39l1.39-1.44a1 1 0 00-1.44-1.39zm2.88 5.47a1 1 0 00.91.59 1 1 0 00.41-.09l1.8-.8a1 1 0 00-.81-1.83l-1.83.81a1 1 0 00-.48 1.32z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fill: "#8d6c9f",
  d: "M30.93 31.51a1.94 1.94 0 00-.93-2.23V21a1 1 0 00-2 0v8.28a2 2 0 001.51 3.65l6.28 6.28a1 1 0 001.41-1.41zm5.42-20.19a21.1 21.1 0 012.1.92 1 1 0 00.45.11 1 1 0 00.45-1.89 22.71 22.71 0 00-2.3-1 1 1 0 00-.7 1.87z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fill: "#8d6c9f",
  d: "M62.83 59.37L54 45.7a29 29 0 10-26.75 14.23A3 3 0 0030 64h30.32a3 3 0 002.52-4.63zM2 31a27 27 0 1150.74 12.82l-2.56-3.95a23 23 0 00-7-27 1 1 0 10-1.23 1.57 21.27 21.27 0 011.91 1.7 21 21 0 015 21.67L47.69 36a3 3 0 00-2.52-1.37A3 3 0 0042.66 36L32.52 51.67a20.81 20.81 0 01-12.11-1.5 21 21 0 0111.93-39.9 1 1 0 10.32-2A23 23 0 1029 54c.71 0 1.41 0 2.11-.11L28.42 58A27 27 0 012 31zm59.2 30.48a1 1 0 01-.88.52H30a1 1 0 01-.84-1.54l15.18-23.33a1 1 0 01.84-.46 1 1 0 01.84.46l15.14 23.33a1 1 0 01.04 1.02z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fill: "#8d6c9f",
  d: "M45 55a2 2 0 100 4 2 2 0 100-4zm0-1a1 1 0 001-.89l.93-8a1.93 1.93 0 00-.51-1.46 2 2 0 00-2.83 0 2 2 0 00-.5 1.49l.92 8A1 1 0 0045 54z"
});

function SvgExpired(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 128,
    height: 128
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
}

export default SvgExpired;